import React, { useState, useEffect, useCallback, useMemo } from 'react';
import './ChatSessionsPage.css';

const API_BASE = process.env.REACT_APP_API_BASE;

function getToken() {
  return localStorage.getItem('auth_token') || sessionStorage.getItem('auth_token');
}
function authHeaders() {
  return { 'Content-Type': 'application/json', Authorization: `Bearer ${getToken()}` };
}

// ── Icons ──────────────────────────────────────────────────────────────────────

function SearchIcon()    { return <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>; }
function LocationIcon()  { return <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>; }
function CloseIcon()   { return <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>; }
function EyeIcon()     { return <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>; }
function AlertIcon()   { return <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>; }
function UserIcon()    { return <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>; }
function BotIcon()     { return <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/><line x1="12" y1="15" x2="12" y2="17"/><circle cx="8" cy="15" r="1" fill="currentColor"/><circle cx="16" cy="15" r="1" fill="currentColor"/></svg>; }
function PhoneIcon()   { return <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 13a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.34 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 9.91a16 16 0 0 0 6.16 6.16l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>; }
function MailIcon()    { return <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>; }
function RefreshIcon() { return <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="23 4 23 10 17 10"/><polyline points="1 20 1 14 7 14"/><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/></svg>; }
function ReplyIcon()   { return <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 17 4 12 9 7"/><path d="M20 18v-2a4 4 0 0 0-4-4H4"/></svg>; }
function CheckIcon()   { return <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>; }

// ── Helpers ────────────────────────────────────────────────────────────────────

function fmtDateTime(iso) {
  if (!iso) return '—';
  try { return new Date(iso).toLocaleString('en-US', { month:'short', day:'numeric', hour:'2-digit', minute:'2-digit' }); }
  catch { return iso; }
}
function fmtNum(n) {
  if (!n && n !== 0) return '—';
  if (n >= 1000000) return (n / 1000000).toFixed(1) + 'M';
  if (n >= 1000)    return (n / 1000).toFixed(1) + 'K';
  return String(n);
}

// ── Chat history modal ─────────────────────────────────────────────────────────

export function ChatModal({ sessionId, onClose }) {
  const [data,    setData]    = useState(null);
  const [loading, setLoading] = useState(true);
  const [err,     setErr]     = useState('');

  useEffect(() => {
    const h = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', h);
    return () => document.removeEventListener('keydown', h);
  }, [onClose]);

  useEffect(() => {
    (async () => {
      setLoading(true);
      setErr('');
      try {
        const res = await fetch(`${API_BASE}/api/admin/sessions/${sessionId}/messages`, { headers: authHeaders() });
        const body = await res.json();
        if (!res.ok) throw new Error(body.detail || 'Failed to load messages.');
        setData(body);
      } catch (e) { setErr(e.message); }
      finally { setLoading(false); }
    })();
  }, [sessionId]);

  return (
    <div className="cs-overlay" onMouseDown={e => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="cs-chat-modal">
        <div className="cs-modal-head">
          <div>
            <h3 className="cs-modal-title">{data?.guidebook_title || 'Chat History'}</h3>
            {data && (
              <div className="cs-modal-sub">
                {fmtDateTime(data.session_start)}
                {data.user_identifier && <> · <UserIcon /> {data.user_identifier}</>}
                {data.location && <> · <LocationIcon /> {data.location}</>}
              </div>
            )}
          </div>
          <button className="cs-modal-close" onClick={onClose}><CloseIcon /></button>
        </div>

        {data && (
          <div className="cs-session-stats">
            <div className="cs-stat"><span className="cs-stat-val">{data.total_messages}</span><span className="cs-stat-label">Messages</span></div>
            <div className="cs-stat"><span className="cs-stat-val">{fmtNum(data.total_input_tokens)}</span><span className="cs-stat-label">In Tokens</span></div>
            <div className="cs-stat"><span className="cs-stat-val">{fmtNum(data.total_output_tokens)}</span><span className="cs-stat-label">Out Tokens</span></div>
            <div className="cs-stat">
              <span className={`cs-status-badge ${data.is_active ? 'cs-badge-active' : 'cs-badge-ended'}`}>
                {data.is_active ? 'Active' : 'Ended'}
              </span>
              <span className="cs-stat-label">Status</span>
            </div>
          </div>
        )}

        <div className="cs-chat-body">
          {loading && <div className="cs-chat-loading">Loading messages…</div>}
          {err     && <div className="cs-chat-err">{err}</div>}
          {data?.messages?.length === 0 && <div className="cs-chat-empty">No messages in this session.</div>}
          {data?.messages?.map((msg, i) => (
            <div key={i} className={`cs-msg cs-msg-${msg.role}`}>
              <div className="cs-msg-role">
                {msg.role === 'user' ? <UserIcon /> : <BotIcon />}
                {msg.role === 'user' ? 'Guest' : 'Assistant'}
                {msg.role === 'assistant' && !msg.was_answered && (
                  <span className="cs-unanswered-tag"><AlertIcon /> Unable to answer</span>
                )}
              </div>
              <div className="cs-msg-bubble">{msg.content}</div>
              <div className="cs-msg-meta">
                {fmtDateTime(msg.created_at)}
                {(msg.input_tokens > 0 || msg.output_tokens > 0) && (
                  <span>
                    {msg.input_tokens > 0  && ` · In: ${msg.input_tokens}`}
                    {msg.output_tokens > 0 && ` · Out: ${msg.output_tokens}`}
                  </span>
                )}
              </div>
            </div>
          ))}
        </div>

        <div className="cs-modal-foot">
          <button className="cs-btn cs-btn-ghost" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
}

// ── Unanswered question detail modal ───────────────────────────────────────────

function UnansweredModal({ uq, onClose, onReplied }) {
  const [replyText,    setReplyText]    = useState('');
  const [replyLoading, setReplyLoading] = useState(false);
  const [replyError,   setReplyError]   = useState('');
  const [replied,      setReplied]      = useState(!!uq.manager_reply);
  const [savedReply,   setSavedReply]   = useState(uq.manager_reply || '');
  const [savedAt,      setSavedAt]      = useState(uq.replied_at || '');
  const [emailSent,    setEmailSent]    = useState(false);

  useEffect(() => {
    const h = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', h);
    return () => document.removeEventListener('keydown', h);
  }, [onClose]);

  const handleReply = async () => {
    if (!replyText.trim()) return;
    setReplyLoading(true);
    setReplyError('');
    try {
      const res = await fetch(`${API_BASE}/api/admin/sessions/unanswered/reply`, {
        method: 'POST',
        headers: authHeaders(),
        body: JSON.stringify({
          session_id: uq.session_id,
          question:   uq.user_question,
          reply_text: replyText.trim(),
        }),
      });
      const body = await res.json();
      if (!res.ok) throw new Error(body.detail || 'Failed to send reply.');
      setSavedReply(replyText.trim());
      setSavedAt(body.replied_at || new Date().toISOString());
      setEmailSent(body.email_sent);
      setReplied(true);
      onReplied(uq.session_id, uq.user_question, replyText.trim(), body.replied_at);
    } catch (e) {
      setReplyError(e.message);
    } finally {
      setReplyLoading(false);
    }
  };

  return (
    <div className="cs-overlay" onMouseDown={e => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="cs-uq-modal">
        <div className="cs-modal-head">
          <div>
            <h3 className="cs-modal-title">Unanswered Question</h3>
            {replied && <div className="cs-modal-sub"><CheckIcon /> Replied {fmtDateTime(savedAt)}</div>}
          </div>
          <button className="cs-modal-close" onClick={onClose}><CloseIcon /></button>
        </div>
        <div className="cs-uq-body">
          <div className="cs-uq-section">
            <div className="cs-uq-label">Guidebook</div>
            <div className="cs-uq-value cs-uq-value--bold">{uq.guidebook_title || '—'}</div>
          </div>
          <div className="cs-uq-section">
            <div className="cs-uq-label">Guest Question</div>
            <div className="cs-uq-bubble cs-uq-bubble--user">{uq.user_question}</div>
          </div>
          <div className="cs-uq-section">
            <div className="cs-uq-label">AI Response</div>
            <div className="cs-uq-bubble cs-uq-bubble--bot">{uq.ai_response}</div>
          </div>
          <div className="cs-uq-section">
            <div className="cs-uq-label">Reason Unable to Answer</div>
            <div className="cs-uq-reason">{uq.reason || '—'}</div>
          </div>

          {uq.contact_provided ? (
            <div className="cs-uq-contact">
              <div className="cs-uq-label">Guest Contact</div>
              <div className="cs-uq-contact-row">
                {uq.user_phone && <span className="cs-contact-pill"><PhoneIcon /> {uq.user_phone}</span>}
                {uq.user_email && <span className="cs-contact-pill"><MailIcon /> {uq.user_email}</span>}
                {!uq.user_phone && !uq.user_email && <span className="cs-uq-none">No contact details provided.</span>}
              </div>
            </div>
          ) : (
            <div className="cs-uq-section">
              <div className="cs-uq-label">Guest Contact</div>
              <div className="cs-uq-none">Guest did not provide contact information.</div>
            </div>
          )}

          {/* ── Reply section ── */}
          <div className="cs-uq-section">
            <div className="cs-uq-label"><ReplyIcon /> Your Reply</div>
            {replied ? (
              <div className="cs-reply-section">
                <div className="cs-reply-existing">{savedReply}</div>
                <div className="cs-reply-meta">
                  Sent {fmtDateTime(savedAt)}
                  {emailSent && <> · Email delivered to guest</>}
                  {!emailSent && uq.user_email === null && <> · No email on file — contact by phone if available</>}
                </div>
              </div>
            ) : (
              <div className="cs-reply-section">
                <textarea
                  className="cs-reply-textarea"
                  placeholder={uq.user_email
                    ? "Write your reply — it will be emailed to the guest automatically."
                    : "Write your reply — no guest email on file, for your records only."}
                  value={replyText}
                  onChange={e => setReplyText(e.target.value)}
                  disabled={replyLoading}
                />
                {replyError && <div className="cs-reply-error">{replyError}</div>}
                <div className="cs-reply-actions">
                  <button
                    className="cs-btn cs-btn-primary"
                    onClick={handleReply}
                    disabled={replyLoading || !replyText.trim()}
                  >
                    {replyLoading
                      ? 'Sending…'
                      : uq.user_email ? <><ReplyIcon /> Send Reply & Email Guest</> : <><ReplyIcon /> Save Reply</>}
                  </button>
                </div>
              </div>
            )}
          </div>

          <div className="cs-uq-meta">
            <span>{fmtDateTime(uq.created_at)}</span>
            <span className="cs-uq-sid">Session: {uq.session_id}</span>
          </div>
        </div>
        <div className="cs-modal-foot cs-modal-foot--pad">
          <button className="cs-btn cs-btn-ghost" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
}

// ── Main page ──────────────────────────────────────────────────────────────────

export default function ChatSessionsPage() {
  const [sessions,    setSessions]    = useState([]);
  const [unanswered,  setUnanswered]  = useState([]);
  const [loading,     setLoading]     = useState(true);
  const [loadingUq,   setLoadingUq]   = useState(true);
  const [fetchErr,    setFetchErr]    = useState('');
  const [activeTab,   setActiveTab]   = useState('sessions');
  const [search,      setSearch]      = useState('');
  const [statusFil,   setStatusFil]   = useState('all');
  const [guideFil,    setGuideFil]    = useState('all');
  const [chatSession, setChatSession] = useState(null);
  const [viewUq,      setViewUq]      = useState(null);

  const handleReplied = useCallback((session_id, question, reply_text, replied_at) => {
    setUnanswered(prev => prev.map(uq =>
      uq.session_id === session_id && uq.user_question === question
        ? { ...uq, manager_reply: reply_text, replied_at }
        : uq
    ));
    // Keep the modal open so the manager sees the "Replied" confirmation
  }, []);

  const load = useCallback(async () => {
    setLoading(true);
    setLoadingUq(true);
    setFetchErr('');
    try {
      const [sRes, uRes] = await Promise.all([
        fetch(`${API_BASE}/api/admin/sessions`,           { headers: authHeaders() }),
        fetch(`${API_BASE}/api/admin/sessions/unanswered`, { headers: authHeaders() }),
      ]);
      if (!sRes.ok) {
        const d = await sRes.json().catch(() => ({}));
        throw new Error(d.detail || 'Failed to load sessions.');
      }
      setSessions(await sRes.json());
      setLoading(false);
      if (uRes.ok) setUnanswered(await uRes.json());
    } catch (e) {
      setFetchErr(e.message);
    } finally {
      setLoading(false);
      setLoadingUq(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  // Unique guidebook list for filter dropdown
  const guideOptions = useMemo(() => {
    const seen = new Set();
    const opts = [];
    for (const s of sessions) {
      if (s.guidebook_title && !seen.has(s.guideid)) {
        seen.add(s.guideid);
        opts.push({ id: s.guideid, title: s.guidebook_title });
      }
    }
    return opts.sort((a, b) => a.title.localeCompare(b.title));
  }, [sessions]);

  const filteredSessions = useMemo(() => {
    let list = sessions;
    if (statusFil === 'active') list = list.filter(s => s.is_active);
    if (statusFil === 'ended')  list = list.filter(s => !s.is_active);
    if (guideFil !== 'all')     list = list.filter(s => s.guideid === guideFil);
    const q = search.trim().toLowerCase();
    if (q) list = list.filter(s =>
      s.guidebook_title?.toLowerCase().includes(q) ||
      s.user_identifier?.toLowerCase().includes(q) ||
      s.session_id?.toLowerCase().includes(q) ||
      s.location?.toLowerCase().includes(q)
    );
    return list;
  }, [sessions, statusFil, guideFil, search]);

  const filteredUq = useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q || activeTab !== 'unanswered') return unanswered;
    return unanswered.filter(u =>
      u.guidebook_title?.toLowerCase().includes(q) ||
      u.user_question?.toLowerCase().includes(q)
    );
  }, [unanswered, search, activeTab]);

  // Analytics — computed from sessions
  const analytics = useMemo(() => {
    const total    = sessions.length;
    const active   = sessions.filter(s => s.is_active).length;
    const messages = sessions.reduce((a, s) => a + (s.total_messages || 0), 0);
    const tokens   = sessions.reduce((a, s) => a + (s.total_input_tokens || 0) + (s.total_output_tokens || 0), 0);

    const byGuide = {};
    for (const s of sessions) {
      const key = s.guideid || '(none)';
      if (!byGuide[key]) byGuide[key] = { title: s.guidebook_title || '—', sessions: 0, messages: 0, tokens: 0 };
      byGuide[key].sessions++;
      byGuide[key].messages += s.total_messages || 0;
      byGuide[key].tokens   += (s.total_input_tokens || 0) + (s.total_output_tokens || 0);
    }
    const perGuide = Object.values(byGuide).sort((a, b) => b.sessions - a.sessions);
    return { total, active, messages, tokens, perGuide };
  }, [sessions]);

  const TABS = [
    { id: 'sessions',   label: `Sessions (${sessions.length})` },
    { id: 'unanswered', label: `Unanswered (${unanswered.length})` },
    { id: 'analytics',  label: 'Analytics' },
  ];

  return (
    <div className="cs-page">

      {/* ── Tab bar ── */}
      <div className="cs-tabs">
        {TABS.map(t => (
          <button
            key={t.id}
            className={`cs-tab${activeTab === t.id ? ' cs-tab--active' : ''}`}
            onClick={() => setActiveTab(t.id)}
          >
            {t.label}
          </button>
        ))}
        <button className="cs-refresh-btn" onClick={load} title="Refresh">
          <RefreshIcon />
        </button>
      </div>

      {fetchErr && <div className="cs-alert">{fetchErr}</div>}

      {/* ════════════════ SESSIONS TAB ════════════════ */}
      {activeTab === 'sessions' && (
        <>
          <div className="cs-filters">
            <div className="cs-search-bar">
              <span className="cs-search-icon"><SearchIcon /></span>
              <input
                className="cs-search-input"
                placeholder="Search by guidebook, user or session ID…"
                value={search}
                onChange={e => setSearch(e.target.value)}
              />
              {search && <button className="cs-search-clear" onClick={() => setSearch('')}><CloseIcon /></button>}
            </div>
            <select className="cs-select" value={statusFil} onChange={e => setStatusFil(e.target.value)}>
              <option value="all">All Status</option>
              <option value="active">Active</option>
              <option value="ended">Ended</option>
            </select>
            <select className="cs-select" value={guideFil} onChange={e => setGuideFil(e.target.value)}>
              <option value="all">All Guidebooks</option>
              {guideOptions.map(g => <option key={g.id} value={g.id}>{g.title}</option>)}
            </select>
          </div>

          <div className="cs-table-card">
            <div className="cs-table-wrap">
              {loading ? (
                <div className="cs-skeleton-rows">
                  {[...Array(6)].map((_, i) => (
                    <div className="cs-skeleton-row" key={i}>
                      <div className="cs-sk" style={{ width: '8%' }} />
                      <div className="cs-sk" style={{ width: '22%' }} />
                      <div className="cs-sk" style={{ width: '18%' }} />
                      <div className="cs-sk" style={{ width: '14%' }} />
                      <div className="cs-sk" style={{ width: '8%' }} />
                      <div className="cs-sk" style={{ width: '12%' }} />
                      <div className="cs-sk" style={{ width: '40px' }} />
                    </div>
                  ))}
                </div>
              ) : (
                <table className="cs-table">
                  <thead>
                    <tr>
                      <th>Guidebook</th>
                      <th>User</th>
                      <th>Location</th>
                      <th>Started</th>
                      <th>Last Msg</th>
                      <th>Msgs</th>
                      <th>In Tokens</th>
                      <th>Out Tokens</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredSessions.length === 0 ? (
                      <tr><td colSpan={9} className="cs-empty">No sessions found.</td></tr>
                    ) : filteredSessions.map(s => (
                      <tr key={s.session_id}>
                        <td className="cs-td-guide">{s.guidebook_title || '—'}</td>
                        <td className="cs-td-user">{s.ip_address || s.user_identifier || '—'}</td>
                        <td className="cs-td-location">
                          {s.location
                            ? <span className="cs-location-tag"><LocationIcon /> {s.location}</span>
                            : <span className="cs-td-muted">—</span>}
                        </td>
                        <td className="cs-td-date">{fmtDateTime(s.session_start)}</td>
                        <td className="cs-td-date">{fmtDateTime(s.last_message_at)}</td>
                        <td className="cs-td-num">{s.total_messages}</td>
                        <td className="cs-td-num">{fmtNum(s.total_input_tokens || 0)}</td>
                        <td className="cs-td-num">{fmtNum(s.total_output_tokens || 0)}</td>
                        <td>
                          <button
                            className="cs-icon-btn"
                            title="View chat history"
                            onClick={() => setChatSession(s.session_id)}
                          >
                            <EyeIcon />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
            {!loading && filteredSessions.length > 0 && (
              <div className="cs-table-foot">
                Showing {filteredSessions.length} of {sessions.length} sessions
              </div>
            )}
          </div>
        </>
      )}

      {/* ════════════════ UNANSWERED TAB ════════════════ */}
      {activeTab === 'unanswered' && (
        <>
          <div className="cs-filters">
            <div className="cs-search-bar">
              <span className="cs-search-icon"><SearchIcon /></span>
              <input
                className="cs-search-input"
                placeholder="Search by guidebook or question…"
                value={search}
                onChange={e => setSearch(e.target.value)}
              />
              {search && <button className="cs-search-clear" onClick={() => setSearch('')}><CloseIcon /></button>}
            </div>
          </div>

          {unanswered.length === 0 && !loadingUq ? (
            <div className="cs-all-answered">
              <div className="cs-all-answered-icon">✓</div>
              <div className="cs-all-answered-text">All questions have been answered!</div>
            </div>
          ) : (
            <div className="cs-table-card">
              <div className="cs-table-wrap">
                {loadingUq ? (
                  <div className="cs-skeleton-rows">
                    {[...Array(4)].map((_, i) => (
                      <div className="cs-skeleton-row" key={i}>
                        <div className="cs-sk" style={{ width: '20%' }} />
                        <div className="cs-sk" style={{ width: '36%' }} />
                        <div className="cs-sk" style={{ width: '14%' }} />
                        <div className="cs-sk" style={{ width: '40px' }} />
                      </div>
                    ))}
                  </div>
                ) : (
                  <table className="cs-table">
                    <thead>
                      <tr>
                        <th>Guidebook</th>
                        <th>Guest Question</th>
                        <th>Contact</th>
                        <th>Status</th>
                        <th>Time</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredUq.length === 0 ? (
                        <tr><td colSpan={6} className="cs-empty">No results found.</td></tr>
                      ) : filteredUq.map((uq, i) => (
                        <tr key={i}>
                          <td className="cs-td-guide">{uq.guidebook_title || '—'}</td>
                          <td className="cs-td-question">{uq.user_question}</td>
                          <td>
                            {uq.contact_provided
                              ? <span className="cs-contact-tag"><PhoneIcon /> Provided</span>
                              : <span className="cs-no-contact">—</span>}
                          </td>
                          <td>
                            {uq.manager_reply
                              ? <span className="cs-replied-badge"><CheckIcon /> Replied</span>
                              : <span className="cs-no-contact">Pending</span>}
                          </td>
                          <td className="cs-td-date">{fmtDateTime(uq.created_at)}</td>
                          <td>
                            <button className="cs-icon-btn" title="View & reply" onClick={() => setViewUq(uq)}>
                              <EyeIcon />
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>
              {!loadingUq && filteredUq.length > 0 && (
                <div className="cs-table-foot">
                  {filteredUq.length} unanswered {filteredUq.length === 1 ? 'question' : 'questions'}
                </div>
              )}
            </div>
          )}
        </>
      )}

      {/* ════════════════ ANALYTICS TAB ════════════════ */}
      {activeTab === 'analytics' && (
        <>
          <div className="cs-kpi-grid">
            {[
              { label: 'Total Sessions',  value: analytics.total,                  accent: '#1A2744' },
              { label: 'Active Now',      value: analytics.active,                 accent: '#16a34a' },
              { label: 'Total Messages',  value: fmtNum(analytics.messages),       accent: '#2a5298' },
              { label: 'Total Tokens',    value: fmtNum(analytics.tokens),         accent: '#C8102E' },
              { label: 'Unanswered',      value: unanswered.length,               accent: '#d97706' },
              { label: 'Guidebooks Used', value: analytics.perGuide.length,        accent: '#7c3aed' },
            ].map(k => (
              <div key={k.label} className="cs-kpi-card" style={{ '--accent': k.accent }}>
                <div className="cs-kpi-val">{loading ? '—' : k.value}</div>
                <div className="cs-kpi-label">{k.label}</div>
              </div>
            ))}
          </div>

          <div className="cs-table-card">
            <div className="cs-section-head">By Guidebook</div>
            <div className="cs-table-wrap">
              <table className="cs-table">
                <thead>
                  <tr>
                    <th>Guidebook</th>
                    <th>Sessions</th>
                    <th>Messages</th>
                    <th>Total Tokens</th>
                    <th>Avg Msgs/Session</th>
                  </tr>
                </thead>
                <tbody>
                  {analytics.perGuide.length === 0 ? (
                    <tr><td colSpan={5} className="cs-empty">No data yet.</td></tr>
                  ) : analytics.perGuide.map((g, i) => (
                    <tr key={i}>
                      <td className="cs-td-guide">{g.title}</td>
                      <td className="cs-td-num">{g.sessions}</td>
                      <td className="cs-td-num">{fmtNum(g.messages)}</td>
                      <td className="cs-td-num">{fmtNum(g.tokens)}</td>
                      <td className="cs-td-num">{g.sessions ? (g.messages / g.sessions).toFixed(1) : '—'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </>
      )}

      {/* ── Modals ── */}
      {chatSession && <ChatModal sessionId={chatSession} onClose={() => setChatSession(null)} />}
      {viewUq      && <UnansweredModal uq={viewUq}      onClose={() => setViewUq(null)} onReplied={handleReplied} />}
    </div>
  );
}
